import React from 'react';
import ManageFileGroupingFileSpecComponentVM from './ManageFileGroupingFileSpecComponentVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { ModalUtils, Validation } from '@singularsystems/neo-core';
import InfoLabelHover from '../../../Common/Components/InfoLabelHover/InfoLabelHover';

interface IManageFileGroupingFileSpecComponentProps {
    viewModel: ManageFileGroupingFileSpecComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageFileGroupingFileSpecComponent extends React.Component<IManageFileGroupingFileSpecComponentProps> {

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>
                {<Neo.Card title={viewModel.managedFileGroupingFileSpec.staticServiceProviderFileGroupingFileSpecId > 0 ? TextConstants.Titles.EditStockbrokerFileConfiguration : TextConstants.Titles.AddStockbrokerFileConfiguration}>
                    <>
                        <Neo.Form
                            model={viewModel.managedFileGroupingFileSpec}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup bindContext={viewModel.managedFileGroupingFileSpec.meta.stockbrokerName}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.staticServiceProviderFileGroupingId}
                                        bindDisplay={viewModel.managedFileGroupingFileSpec.meta.stockbrokerName}
                                        displayMember={"serviceProviderGroupingName"}
                                        isReadOnly={viewModel.isFieldReadOnlyInd}
                                        items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                    />
                                </Neo.FormGroup>
                                <Neo.FormGroup bindContext={viewModel.managedFileGroupingFileSpec.meta.fileTypeConcatenated} label={TextConstants.Labels.FileType}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.staticFileSpecId}
                                        bindDisplay={viewModel.managedFileGroupingFileSpec.meta.fileType}
                                        displayMember={"propertiesConcatenated"}
                                        isReadOnly={viewModel.isFieldReadOnlyInd}
                                        onItemSelected={() => viewModel.updateActiveStartEndDates()}
                                        items={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.propertiesConcatenated.localeCompare(y.propertiesConcatenated)))}
                                    />
                                </Neo.FormGroup>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ActiveStartDate}
                                    bind={viewModel.managedFileGroupingFileSpec.meta.activeStartDate}
                                    isReadOnly={true} />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ActiveEndDate}
                                    bind={viewModel.managedFileGroupingFileSpec.meta.activeEndDate}
                                    isReadOnly={true} />
                            </Neo.GridLayout>
                            <div className="row">
                                <div className="col-lg-3">
                                    <Neo.FormGroup
                                        label={<InfoLabelHover title={TextConstants.Labels.FileNameConvention} content={TextConstants.Tooltips.FileNameConventionTooltip}/>}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.fileNameConvention}
                                        placeholder={TextConstants.PlaceHolder.FileNameConvention} />
                                </div>
                                <div className="col-lg-3">
                                    <Neo.FormGroup
                                        label={<InfoLabelHover title={TextConstants.Labels.ProcessSortOrder} content={TextConstants.Tooltips.ProcessSortOrderTooltip}/>}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.processSortOrder}
                                        placeholder={TextConstants.PlaceHolder.ProcessSortOrder} />
                                </div>
                                <div className="col-lg-2 pt-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.IgnoreFile}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.ignoreFileInd}
                                        input={{ type: "checkbox" }} />
                                </div>
                                <div className="col-lg-2 pt-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.CriticalFile}
                                        bind={viewModel.managedFileGroupingFileSpec.meta.isCriticalFileInd}
                                        input={{ type: "checkbox" }} />
                                </div>
                            </div>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </>
                </Neo.Card>}
            </>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidBrokerFileConfiguration);
        }
    }
}